import BaseModel from "./base-model";
import Delivery from "./Delivery";

import { formatDate, getDateByTimeZone } from "@/lib/date";

export default class DeliveryCollectedLog extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  get deliveryObj() {
    return this.delivery ? new Delivery(this.delivery) : {};
  }

  get logWriter() {
    if (this.rider) {
      return `${this.rider?.name}(라이더앱)`;
    } else {
      return "";
    }
  }

  renderCreatedAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.createdAt &&
      formatDate(getDateByTimeZone(this.createdAt), dateFormat)
    );
  }

  renderCollectionType() {
    if (this.mainOffice) {
      return "본사확인";
    } else if (!!this.imagePath) {
      if (this.etc?.withCs) {
        return "CS회수촬영";
      }
      return "회수촬영";
    } else {
      return "회수스캔";
    }
  }
}
